import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import {FormGroup, FormControl, Validators} from "@angular/forms";

@Component({
  selector: "app-available-statuses",
  standalone: false,
  templateUrl: "./available-statuses.component.html",
  styleUrl: "./available-statuses.component.scss",
})
export class AvailableStatusesComponent implements OnInit {
  translate: any;
  color: string = "#BDBDBD";
  data: any;
  statusList: any = [];
  statusForm: FormGroup;

  constructor(
    public modalRef: BsModalRef,
    private languageTranslateService: LanguageTranslateService,
  ) {
    this.statusForm = new FormGroup({
      label: new FormControl(null, [Validators.required]),
      customerPortalLabel: new FormControl(null, [Validators.required]),
      code: new FormControl(null, [Validators.required]),
      color: new FormControl("#FFFFFF"),
      colorInput: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.getLanguageData();
    console.log(this.data, "data printing in ng oninit");
    this.statusList = this.data;
    this.statusList.map ((s: any) =>{
      if (!s.color){
        s['color'] = '#ffffff'
      }

      return {...s}
    })
  }
  getLanguageData() {
    this.languageTranslateService.wordSrc$.subscribe((data) => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
      }
    });
  }

  onColorPickerChange(event: any) {
    this.statusForm.patchValue({
      colorInput: event.value,
    });
  }

  onStatusAdd() {
    if (this.statusForm.valid) {
      //append the value to the table
      this.statusList.push({
        label: this.statusForm.get("label")?.value,
        name: this.statusForm.get("code")?.value,
        color: this.statusForm.get("color")?.value,
        customerPortalLabel: this.statusForm.get("customerPortalLabel")?.value,
      });
    } else {
      this.statusForm.markAllAsTouched();
    }
  }

  onLabelChange() {
    let statusLabelValue = this.statusForm.get("label")?.value;
    let formattedLabel = statusLabelValue
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "_");
    this.statusForm.patchValue({
      code: formattedLabel,
    });
  }
}
